import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ADJUSTMENT_SURCHARGE_RESPONSE,
  GET_JOBS_PARAMS_REQUEST,
  JOB_DETAIL_TYPE,
  JOB_TRANSACTION_PARAMS_REQUEST,
  JOB_TRANSACTION_STATE,
  JOBS_BODY_RESULT,
} from 'models';

export interface JobsType {
  jobs: {
    jobs_list: JOBS_BODY_RESULT;
    jobs_detail: JOB_DETAIL_TYPE | null;
    jobs_transaction: JOB_TRANSACTION_STATE;
  };
  isAllowCreateTrialJob: boolean;
  adjustmentSurcharge: ADJUSTMENT_SURCHARGE_RESPONSE;
}

const initialState: JobsType = {
  jobs: {
    jobs_list: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: {
        sort: 'createdAt-desc',
        page: 1,
        limit: 50,
      },
    },
    jobs_detail: null,
    jobs_transaction: {
      records: [],
      metadata: {
        page: 1,
        limit: 50,
        page_count: 1,
        total_pages: 1,
        total_count: 1,
      },
      params: {
        page: 1,
        limit: 50,
      },
    },
  },
  isAllowCreateTrialJob: false,
  adjustmentSurcharge: {
    records: [],
    metadata: {
      page: 1,
      limit: 50,
      page_count: 1,
      total_pages: 1,
      total_count: 1,
    },
  },
};

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    setIsAllowCreateTrialJob(state: JobsType, action: PayloadAction<boolean>) {
      state.isAllowCreateTrialJob = action.payload;
    },
    setJobsListSuccess(
      state: JobsType,
      action: PayloadAction<JOBS_BODY_RESULT>
    ) {
      state.jobs.jobs_list = {
        ...state.jobs.jobs_list,
        ...action.payload,
      };
    },
    setJobsDetailSuccess(state: JobsType, action: PayloadAction<any | null>) {
      state.jobs.jobs_detail = action.payload;
    },
    setJobsListParams(
      state: JobsType,
      action: PayloadAction<GET_JOBS_PARAMS_REQUEST | null>
    ) {
      state.jobs.jobs_list.params = action.payload;
    },
    setJobTransactionParams(
      state: JobsType,
      action: PayloadAction<JOB_TRANSACTION_PARAMS_REQUEST | null>
    ) {
      state.jobs.jobs_transaction.params = action.payload;
    },
    setJobTransactionSuccess(
      state: JobsType,
      action: PayloadAction<JOB_TRANSACTION_STATE>
    ) {
      state.jobs.jobs_transaction = {
        ...state.jobs.jobs_transaction,
        ...action.payload,
      };
    },
    setAdjustmentSurchargeList(
      state: JobsType,
      action: PayloadAction<ADJUSTMENT_SURCHARGE_RESPONSE>
    ) {
      state.adjustmentSurcharge = {
        ...state.adjustmentSurcharge,
        ...action.payload,
      };
    },
  },
});

// Actions
export const {
  setJobsListSuccess,
  setJobsDetailSuccess,
  setJobsListParams,
  setJobTransactionParams,
  setJobTransactionSuccess,
  setIsAllowCreateTrialJob,
  setAdjustmentSurchargeList,
} = jobsSlice.actions;

export default jobsSlice.reducer;
